// Normalize merchant names for consistent matching

export function normalizeMerchantName(name: string): string {
  if (!name) return '';
  
  let normalized = name.toLowerCase().trim();
  
  // Remove store numbers (e.g., #4532, #112, Store 456)
  normalized = normalized.replace(/#\d+/g, '');
  normalized = normalized.replace(/store\s+\d+/gi, '');
  normalized = normalized.replace(/location\s+\d+/gi, '');
  
  // Remove common suffixes
  normalized = normalized.replace(/\s+(inc|llc|ltd|corp|co)\.?$/i, '');
  
  // Remove extra punctuation
  normalized = normalized.replace(/[^\w\s]/g, ' ');
  
  // Normalize whitespace
  normalized = normalized.replace(/\s+/g, ' ').trim();
  
  return normalized;
}

export function areMerchantsEqual(merchant1: string, merchant2: string): boolean {
  const norm1 = normalizeMerchantName(merchant1);
  const norm2 = normalizeMerchantName(merchant2);
  
  return norm1 === norm2;
}
